export class Config {
  // public static URL_BASE: String = 'https://toolsmexico-oficial.wl.r.appspot.com';
  // public static URL_LISTA_NEGRA_SAT: String = 'http://localhost:8080';
  public static URL_LISTA_NEGRA_SAT: String = 'https://lista-negra-sat.tnk.mx';
  public static URL_PDF_BUILDER: String = 'https://toolsmexico-pdfbuilder-api.uc.r.appspot.com';
  //public static URL_PDF_BUILDER: String = 'http://localhost:8080';

  public static URL_BASE: String = Config.getUrl();
   //public static URL_BASE: String = 'http://192.168.100.9:9000';

  static getUrl(): string {
    let subDominio = location.hostname.replace('http://', '').replace('https://', '').split('.')[0];
    if (subDominio.includes('localhost')) {
       return 'http://localhost:9000';

    }
    subDominio = subDominio.replace('localhost', 'prueba');
    // subDominio = subDominio.replace('localhost', 'erp');
    console.log('Identificador ' + subDominio);
    return 'https://' + subDominio + '.api.tnk.mx' + Config.getPuerto(subDominio);
  }

  static getPuerto(identificador: string): string {
    switch (identificador) {
      default:
        return '';
    } 
  }
}
